<template>
  <v-card flat>
    <v-card-text>
        <v-row
        justify="space-between"
        align="center"
        style="margin-bottom: 20px;"
        >
            <!-- Mostrar datos de -->
            <div>
                <v-select
				v-model="selectedTable"
				@change = "onTableChanged"
				dense
				:items="tables"
				item-text="name"
				item-value="entity"
				:label="$t('wkt.admin.qbuilder.show_data_from')"
				>
					<template slot="item" slot-scope="data">
						{{ $t(data.item.name) }}
					</template>
					<template slot="selection" slot-scope="data">
						{{ $t(data.item.name) }}
					</template>
                </v-select>
            </div>
            <!-- Max. Resultados -->
            <div>
                <v-form v-model="validRowNumberForm" v-if="!saving && selectedTable">
                    <v-text-field 
                        :label="$t('wkt.admin.qbuilder.max_results')"
                        class="mt-n2"
                        required
                        v-model="numberRows"
                        :rules="[rules.required, rules.maxAndIntQueryRows]"
                    ></v-text-field>
                </v-form>
            </div>
            <!-- Boton Ver datos -->
            <div>
                <v-btn class="mt-n4" dark @click="runQuery" :disabled="undefinedEntity"
                v-if="selectedTable && !saving"
                style="background-color: transparent;
                    color: #185ea9!important;
                    border-radius: 30px;
                    text-transform: uppercase;
                    padding: 0 15px!important;
                    font-size: .9rem!important;
                    box-shadow: none;" 
                >
                   <v-icon style="font-size: 20px;">play_arrow</v-icon>
                    {{ $t('wkt.admin.qbuilder.view_data') }}
                </v-btn>
            </div>
            
            <div>
                <v-text-field  v-if="saving"
                        :label="$t('wkt.admin.qbuilder.name_request')"
                        class="mt-n2"
                        required
                        v-model="queryName"
                ></v-text-field>
            </div>

            <!-- Boton Guardar y Favoritos -->
            <div>
                <v-btn class="mt-n4" dark @click="onSaveClick" v-if="selectedTable" 
                v-bind:style="{'background-color': 'transparent !important',
                       'color': (saving?'green':'#185ea9') + ' !important',
                       'border-radius': ' 30px',
                       'text-transform': ' uppercase',
                       'padding': '0 15px !important',
                       'font-size': '.9rem !important',
                       'box-shadow': 'none !important'}" 
                >
                   <v-icon style="font-size: 20px;">bookmark_border</v-icon>
                    {{ $t('wkt.admin.qbuilder.add_bookmark') }}
                </v-btn>
                
                <v-btn class="mt-n4" dark @click="saving=false"  v-if="saving" :disabled="undefinedEntity"
                style="background-color: transparent !important;
                       color: red !important;
                       text-transform: uppercase; 
                       border-radius: 30px;
                       padding: 0 15px!important;
                       font-size: .9rem !important;
                       box-shadow: none !important;
                       font-weight: normal !important;" 
                >
                   <v-icon style="font-size: 20px;">cancel</v-icon>
                    {{ $t('wkt.admin.qbuilder.cancel') }}
                </v-btn>
                <v-menu v-if="!saving" bottom left :disabled="!savedQueries || savedQueries.length==0">
                     <template v-slot:activator="{ on, attrs }">
                        <v-btn class="mt-n4" dark 
                       v-bind:style="{'background-color': 'transparent !important',
                       'color': (!savedQueries || savedQueries.length==0?'grey':'#185ea9') + ' !important',
                       'border-radius': ' 30px',
                       'margin': ' 0 5px',
                       'text-transform': ' uppercase',
                       'padding': '0 15px!important',
                       'font-size': '.9rem !important',
                       'box-shadow': 'none !important',
                       'font-weight': 'normal !important'}"  
                        v-bind="attrs"
                        v-on="on"

                        >
                        <v-icon style="font-size: 20px;">book</v-icon>
                            {{ $t('wkt.admin.qbuilder.show_bookmarks') }}
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item two-line link
                        v-for="(item, index) in savedQueries"
                        :key="index"
                        >
                        <v-list-item-content @click="loadQuery(item)">
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                            <v-list-item-subtitle>{{ item.updateDate }}</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action style="display:block;">
                         <!--   <v-btn icon>
                                <v-icon color="grey lighten-1" style="font-size: 20px;">content_copy</v-icon>
                            </v-btn> -->
                            <v-btn icon>
                                <v-icon color="grey lighten-1" @click="removeQuery(index)">delete_outline</v-icon>
                            </v-btn>
                        </v-list-item-action>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </div>  
        </v-row>
      
      <v-alert v-if="undefinedEntity"
      outlined
      type="warning"
      prominent
      border="left"
    >
      Esta entidad no está definida
    </v-alert>
      
      <v-row v-if="!undefinedEntity"
        justify="space-between"
        align="center" class="mt-n4 mb-1"
      >
      <v-col cols="4">
          <div
                style="width:100%"
                class="d-flex justify-space-between align-center"
              >
                <span style="color:#17a7c1" class="font-weight-bold grey--text"
                  >{{ $t('wkt.admin.qbuilder.columns') }} ({{ addedColumns.length }}/{{ columns.length }})</span
                >
                <v-btn
                  @click="addAllColumns" v-if="!selectAllColumns"
                  class="caption primary--text"
                  small
                  text
                  >{{ $t('wkt.admin.qbuilder.select_all') }}</v-btn
                >
                <v-btn @click="removeAllColumns" v-if="selectAllColumns"
                    small outlined text
                  >{{ $t('wkt.admin.qbuilder.remove_all_columns') }}</v-btn
                >
              </div>
              <v-divider></v-divider>
      </v-col>  
      <v-col cols="8">
            <div
                style="width:100%"
                class="d-flex justify-space-between align-center"
              >
                <span style="color:#17a7c1" class="font-weight-bold grey--text"
                  >{{ $t('wkt.admin.qbuilder.filters') }}</span
                >
                 <v-btn
                  @click="addFilter"
                  class="caption primary--text"
                  small ref="addFilter"
                  text 
                  >{{ $t('wkt.admin.qbuilder.add_filter') }}</v-btn>
            </div>
            <v-divider></v-divider>
      </v-col>
      </v-row>


      <v-row v-if="!undefinedEntity"
        class="mb-5" 
        justify="space-between"
        no-gutters
      >
        <v-col cols="3">
          <v-list
            style="height: 67vh;"
            class="overflow-y-auto"
            two-line
            subheader
          >
            <v-list-item v-for="item in columns" :key="item.field">
              <v-list-item-content>
                <v-list-item-title v-text="item.field"></v-list-item-title>
                <v-list-item-subtitle v-text="$t(item.desc)"></v-list-item-subtitle
                >
              </v-list-item-content>

              <v-list-item-action style="display: block;">
                  <v-btn @click="addFilter(item)" small icon >
                    <v-icon color="secondary lighten-1">filter_list</v-icon>
                  </v-btn>
                <v-btn small icon
                  class="ma-0 pa-0" @click="removeColumns(item)" 
                  v-if="addedColumns.includes(item)">
                  <v-icon color="green lighten-1">check_circle</v-icon></v-btn>
                <v-btn @click="addColumn(item)" small v-else icon>
                  <v-icon color="green lighten-1">add</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-col>

        <v-col cols="9">
            <v-form ref="filterForm"
                style="height: 67vh; padding-left: 20px; padding-bottom: 20px;"
                class="overflow-y-auto"
            >
            <v-row
            v-for="(filter, index) in addedFilters"
            :key="filter.index" align="center" 
            justify="start"
            flex-wrap style="width: 100%; height:94px; padding-top:20px }"
            no-gutters
            >
            <v-col cols="1" style="min-width: 122px">
                <div class="d-flex align-center mt-n3">
                <v-btn-toggle small :disabled="index==0"
                            v-model="addedFilters[index].andOrOr">
                    <v-btn small text value="and" :disabled="index==0">
                    and
                    </v-btn>
                    <v-btn small text value="or" :disabled="index==0">
                    or
                    </v-btn>
                </v-btn-toggle>
                </div>
            </v-col>
            <v-col class="mr-2" cols="2">
                <v-select
                @change="clearFilterDataUponColumnChange(index)"
                dense
                v-model="addedFilters[index].column"
                :items="columns"
                item-text="field"
                item-value="field"
                :label="$t('wkt.admin.qbuilder.column')"
                ></v-select>
            </v-col>
            <v-col v-if="addedFilters[index].column" cols="2">
                <v-select
                dense
                :items="columnFilters(filter.column)"
                v-model="addedFilters[index].filter"
                class="mr-2"
                :label="$t('wkt.admin.qbuilder.condition')"
                ></v-select>
            </v-col>
            <v-col
                v-if="
                addedFilters[index].column &&
                    addedFilters[index].filter &&
                    ['DATE', 'TIME', 'DATETIME','SIMPLEDATE'].includes(
                    colType(addedFilters[index].column)
                    ) === false &&
                    addedFilters[index].file === null
                "
                class="mr-2"
                cols="2"
            >
                <v-text-field v-if="!colChoices(filter.column)"
                :rules="[colType(addedFilters[index].column) === 'NUMERIC' ? rules.requiredNumeric: rules.required]"
                autocomplete="new-value"
                :label="$t('wkt.admin.qbuilder.value')"
                v-model="addedFilters[index].inputField1"
                dense
                ></v-text-field>
                <v-select
                dense v-if="colChoices(filter.column)"
                :items="colChoices(filter.column)"
                v-model="addedFilters[index].inputField1"
                class="mr-2" item-text="value" item-value="key"
                :label="$t('wkt.admin.qbuilder.choice')"
                >
									<template slot="item" slot-scope="data">
										{{ $t(data.item.value) }}
									</template>
									<template slot="selection" slot-scope="data">
										{{ $t(data.item.value) }}
									</template>
								</v-select>
            </v-col>
            <v-col
                v-if="
                addedFilters[index].column &&
                    addedFilters[index].filter &&
                    addedFilters[index].filter === 'between' &&
                    colType(addedFilters[index].column) === 'NUMERIC'
                "
                cols="1"
            >
                <div class="d-flex justify-center">
                <span class="text-uppercase">and</span>
                </div>
            </v-col>
            <v-col
                v-if="
                addedFilters[index].column &&
                    addedFilters[index].filter &&
                    addedFilters[index].filter === 'between' &&
                    colType(addedFilters[index].column) === 'NUMERIC'
                "
                cols="2"
            >
                <v-text-field
                required v-if="!colChoices(filter.column)"
                :label="$t('wkt.admin.qbuilder.value')"
                v-model="addedFilters[index].inputField2"
                :rules="[colType(addedFilters[index].column) === 'NUMERIC' ? rules.requiredNumeric: rules.required]"
                dense
                ></v-text-field>
                <v-select
                dense v-if="colChoices(filter.column)"
                :items="colChoices(filter.column)"
                v-model="addedFilters[index].inputField2"
                class="mr-2" item-text="value" item-value="key"
                :label="$t('wkt.admin.qbuilder.choice')"
                >
									<template slot="item" slot-scope="data">
										{{ $t(data.item.value) }}
									</template>
									<template slot="selection" slot-scope="data">
										{{ $t(data.item.value) }}
									</template>
								</v-select>
            </v-col>
            <v-col
                v-if="
                addedFilters[index].column &&
                    addedFilters[index].filter &&
                    addedFilters[index].filter == 'in'
                "
                cols="2"
            >
                <div class="d-flex align-center">
                <v-file-input
                    dense
                    :hide-input="addedFilters[index].file === null"
                    v-model="addedFilters[index].file"
                    @change="uploadFile($event, index)"
                    accept=".txt"
										:label="$t('wkt.admin.qbuilder.upload_file')"
                ></v-file-input>
                </div>
            </v-col>
            <v-col
                v-if="
                addedFilters[index].column &&
                    addedFilters[index].filter &&
                    addedFilters[index].filter !== 'in' &&
                    addedFilters[index].filter !== 'is null' &&
                    addedFilters[index].filter !== 'is not null' &&
                    ['DATE', 'DATETIME','SIMPLEDATE'].includes(
                    colType(addedFilters[index].column)
                    )
                "
                class="mr-2"
                cols="2"
            >
                <v-menu
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                min-width="290px"
                >
                <template v-slot:activator="{ on }">
                    <v-text-field
                    v-model="addedFilters[index].datePicker1"
                    :label="
                        addedFilters[index].filter === 'between'
                        ? $t('wkt.admin.qbuilder.start_date')
                        : $t('wkt.admin.qbuilder.date')
                    "
                    readonly
                    v-on="on"
                    dense
                    :rules="[rules.required]"
                    ></v-text-field>
                </template>
                <v-date-picker
                    v-model="addedFilters[index].datePicker1"
                    no-title
                    scrollable
                ></v-date-picker>
                </v-menu>
            </v-col>
            <v-col
                v-if="
                addedFilters[index].column &&
                    addedFilters[index].filter &&
                    addedFilters[index].filter !== 'is null' &&
                    addedFilters[index].filter !== 'is not null' &&
                    addedFilters[index].filter !== 'in' &&
                    ['TIME', 'DATETIME'].includes(
                    colType(addedFilters[index].column)
                    )
                "
                cols="2"
            >
                <v-menu
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
                >
                <template v-slot:activator="{ on }">
                    <v-text-field
                    v-model="addedFilters[index].timePicker1"
                    :label="
                        addedFilters[index].filter === 'between'
                        ? $t('wkt.admin.qbuilder.start_time')
                        : $t('wkt.admin.qbuilder.time')
                    "
                    readonly
                    v-on="on"
                    dense
                    :rules="[rules.required]"
                    ></v-text-field>
                </template>
                <v-time-picker
                    v-model="addedFilters[index].timePicker1"
                    use-seconds
                    format="24hr"
                    scrollable
                ></v-time-picker>
                </v-menu>
            </v-col>
            <v-col
                v-if="
                addedFilters[index].column &&
                    addedFilters[index].filter &&
                    ['DATE', 'DATETIME', 'TIME','SIMPLEDATE'].includes(
                    colType(addedFilters[index].column)
                    ) &&
                    addedFilters[index].filter === 'between'
                "
                cols="1"
            >
                <div class="d-flex justify-center">
                <span class="text-uppercase">and</span>
                </div>
            </v-col>
            <v-col
                v-if="
                addedFilters[index].column &&
                    addedFilters[index].filter &&
                    ['DATE', 'DATETIME','SIMPLEDATE'].includes(
                    colType(addedFilters[index].column)
                    ) &&
                    addedFilters[index].filter === 'between'
                "
                cols="2"
            >
                <v-menu
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                min-width="290px"
                >
                <template v-slot:activator="{ on }">
                    <v-text-field
                    v-model="addedFilters[index].datePicker2"
                    :label="$t('wkt.admin.qbuilder.end_date')"
                    readonly
                    v-on="on"
                    dense
                    :rules="[rules.required]"
                    ></v-text-field>
                </template>
                <v-date-picker
                    v-model="addedFilters[index].datePicker2"
                    no-title
                    scrollable
                ></v-date-picker>
                </v-menu>
            </v-col>
            <v-col
                v-if="
                addedFilters[index].column &&
                    addedFilters[index].filter &&
                    ['TIME', 'DATETIME'].includes(
                    colType(addedFilters[index].column)
                    ) &&
                    addedFilters[index].filter === 'between'
                "
                class="ml-2"
                cols="2"
            >
                <v-menu
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
                >
                <template v-slot:activator="{ on }">
                    <v-text-field
                    v-model="addedFilters[index].timePicker2"
                    :label="$t('wkt.admin.qbuilder.end_time')"
                    readonly
                    v-on="on"
                    dense
                    :rules="[rules.required]"
                    ></v-text-field>
                </template>
                <v-time-picker
                    use-seconds
                    v-model="addedFilters[index].timePicker2"
                    format="24hr"
                    scrollable
                ></v-time-picker>
                </v-menu>
            </v-col>
            <v-col cols="1" style="margin-left: auto;">
                <div class="d-flex align-center mt-n4">
                <v-btn @click="removeFilter(filter.index)" color="error" icon>
                    <v-icon>delete_outline</v-icon></v-btn>
                </div>
            </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import QBModel from './QBModel'
import gwt from '../../../api/gwt'
import api from '../../../api/worktime'

export default {
  name: "QueryBuilder",
  data() {
    return {
      addedFilters: [],
      undefinedEntity: false,
      filterIndex: 0,
      columnSearch: "",
      validRowNumberForm: true,
      validFilters: false,
      saving: false,
      numberRows: 250,
      queryName: "Nueva consulta",
      addedColumns: [],
      savedQueries: [],
      file: "",
      rules: {
        required: value => !!value || this.$t('wkt.admin.qbuilder.required'),
		requiredNumeric: value => !!value && !isNaN(value) || this.$t('wkt.admin.qbuilder.required_number'),
        maxAndIntQueryRows: value =>
          (!!parseInt(value) && value >= 0 && value <= 5000) ||
          this.$t('wkt.admin.qbuilder.value_must_be_between', { '0': 1, '1': 5000 })
      },
      selectAllColumns: false,
      tables: QBModel.tables,
      filters: [
        "equal",
        "not equal",
        "greater than",
        "less than",
        "between",
        "in",
        "is null",
        "is not null"
      ],
      selectedTable: null,
      columns: [
      ],
      operators: {
        "greater than": ">",
        "less than": "<",
        equal: "=",
        "not equal": "<>",
        in: "in",
        between: "between",
        'is null': 'is null',
        'is not null': 'is not null'
      }
    };
  },
  methods: {
    onSaveClick() {
        
        if (this.saving) {
            this.saveQuery();
        }

        this.saving = !this.saving;
    },
    saveQuery() {
        let data = { 'title':this.queryName, 
                    'entity': this.selectedTable,
                    'addedColumns':this.addedColumns,
                    'addedFilters':this.addedFilters,
                    'numberRows': this.numberRows,
                    'updateDate' : new Date().toLocaleString()
                    };
        this.savedQueries.unshift(data);
        this.presistSavedQueries();
    },
    removeQuery(index) {
        this.savedQueries.splice(index,1);
        this.presistSavedQueries();
    },
    loadSavedQueries() {
     
      api.getDataBag('admin.qb.bookmarks',
				data => {
					this.savedQueries=data?JSON.parse(data.value):[];
				},
				err => {
					console.log(err);
					this.doShowAlert({ text: err.message, color: 'error', timeout: 3000 });
				});	

    },
    presistSavedQueries() {
      
        let db = { 'key':'admin.qb.bookmarks',
                    'value':JSON.stringify(this.savedQueries)}
        api.storeDataBag(db,
				res => {
					console.log(res);
				},
				err => {
					console.log(err);
					this.doShowAlert({ text: err.message, color: 'error', timeout: 3000 });
				});	

    },
    loadQuery(query) {
        
        
        if (!QBModel.columns[query.entity]) return;

        this.selectedTable=query.entity;
        this.undefinedEntity = false;
        this.queryName=query.title;
        this.columns = QBModel.columns[this.selectedTable];
        this.addedColumns = query.addedColumns?query.addedColumns:[];
        this.addedFilters = query.addedFilters?query.addedFilters:[];
        this.numberRows = query.numberRows?query.numberRows:250;
    },
    runQuery() {
        if (!this.$refs.filterForm.validate()) return;
        
        this.$emit('run', { 'entity': this.selectedTable,
                            'rawQuery': this.hqlQuery, 
                            'maxResults' : this.numberRows,
                            'addedColumns': (this.addedColumns.length==0 ? this.columns : this.addedColumns)
                            })
    },
    onTableChanged() {

        this.undefinedEntity = !QBModel.columns[this.selectedTable];
        
        if (this.undefinedEntity) return;

        this.columns = QBModel.columns[this.selectedTable];
        this.addedColumns = [];
        this.addedFilters = [];

        let table = this.getTable(this.selectedTable);
        if (table) this.queryName=this.$t(table.name);
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    addColumn: function(colData) {
      if (this.$data.addedColumns.includes(colData) === false) {
        this.$data.addedColumns.push(colData);
      }
    },
    addAllColumns: function() {
      this.$data.addedColumns = Array.from(this.$data.columns);
    },
    removeColumns: function(colData) {
      const index = this.$data.addedColumns.indexOf(colData);
      if (index > -1) {
        this.$data.addedColumns.splice(index, 1);
      }
      this.$data.addedFilters = this.$data.addedFilters.filter(
        filter => filter.column !== colData.field
      );
    },
    removeAllColumns: function() {
      this.$data.addedColumns = [];
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    loadTextFromFile(ev) {
      const file = ev.target.files[0];
      const reader = new FileReader();
      reader.onload = e => this.setFileContentForFilter(e.target.result);
      reader.readAsText(file);
    },
    uploadFile(evt, filterIdx) {
      console.log(evt);
      if (evt !== undefined && evt !== null) {
        var reader = new FileReader();
        reader.readAsText(evt);
        reader.onload = () => {
          this.setFileContentForFilter(reader.result, filterIdx);
        };
      } else {
        this.$data.addedFilters[filterIdx].fileContent = null;
        this.$data.addedFilters[filterIdx].file = null;
        this.$data.addedFilters[filterIdx].inputField1 = null;
      }
    },
    setFileContentForFilter(fileData, filterIdx) {
      console.log("setting data");
      const filter = this.$data.addedFilters[filterIdx];
      var formatterData;
      if (filter && this.colType(filter.column) === "NUMERIC") {
        formatterData = fileData
          .split("\n")
          .map(dataPoint => parseInt(dataPoint));
      } else {
        formatterData = fileData
          .split("\n")
          .map(dataPoint => dataPoint.toString());
      }
      this.$data.addedFilters[filterIdx].fileContent = formatterData;
      this.$data.addedFilters[filterIdx].inputField1 = formatterData;
    },
    addFilter(colData = null) {
      let id = this.$data.filterIndex;
      let filterData = {
        index: id,
        column: null,
        andOrOr: "and",
        filter: null,
        inputField1: null,
        inputField2: null,
        datePicker1: null,
        datePicker2: null,
        timePicker1: null,
        timePicker2: null,
        file: null,
        fileContent: null
      };
      if (colData !== null) {
        filterData.column = colData.field;
      }
      this.$data.addedFilters.push(filterData);
      this.$data.filterIndex += 1;
    },
    removeFilter(filterIndex) {
      this.$data.addedFilters = this.$data.addedFilters.filter(
        filter => filter.index !== filterIndex
      );
    },
    clearFilterDataUponColumnChange(filterArrayIndex) {
      this.$data.addedFilters[filterArrayIndex].filter = null;
      this.$data.addedFilters[filterArrayIndex].inputField1 = null;
      this.$data.addedFilters[filterArrayIndex].inputField2 = null;
      this.$data.addedFilters[filterArrayIndex].datePicker1 = null;
      this.$data.addedFilters[filterArrayIndex].datePicker2 = null;
      this.$data.addedFilters[filterArrayIndex].timePicker1 = null;
      this.$data.addedFilters[filterArrayIndex].timePicker2 = null;
      this.$data.addedFilters[filterArrayIndex].fileContent = null;
    },
    colType(col) {
      if (col) {
        const colData = this.$data.columns.find(item => item.field === col);
        return colData.type;
      }
    },
    colChoices(col) {
      if (col) {
        const colData = this.$data.columns.find(item => item.field === col);
        return colData.choices;
      }
    },
    columnFilters(col) {
      if (col !== null && col !== undefined) {
        const colData = this.$data.columns.find(item => item.field === col);
        if (
          ["NUMERIC", "DATE", "SIMPLEDATE", "TIME", "DATETIME"].includes(colData.type) ===
          true
        ) {
          return [
            "equal",
            "not equal",
            "greater than",
            "less than",
            "between",
            "in", "is null", "is not null"
          ];
        } else if (colData.type === "CHARACTER") {
          return ["equal", "not equal", "in", "is null", "is not null"];
        }
      } else {
        return [];
      }
    },
    onReveal() {
        if (!gwt.getSessionInformation()) {
            setTimeout(this.onReveal,1000);
            return;
        }
        let profile = gwt.getSessionProfile();
        let isSuperAdmin = gwt.getSessionInformation()?gwt.getSessionInformation().employee.isSuperAdmin:false;

        this.tables = QBModel.tables.filter( (item) => { return isSuperAdmin || !item.roles || this.matchRole(profile,item.roles)});

        this.selectedTable = this.tables && this.tables.length>0? this.tables[0].entity : null;
        this.onTableChanged();
        this.loadSavedQueries();
    },
    matchRole(profile,roles) {
        
        for (let role of roles) {
            if (profile[role] && (profile[role]===1 || profile[role]===2)) {
                return true;
            }
        }

        return false;
    },
    getTable(entity) {
        if (!this.tables) return;

        return this.tables.find(table => table.entity==entity);
    },
    fixNumberFormat(value) {
        try {
            if (value.indexOf('.')>=0 || value.indexOf(',')>=0) {
                return parseFloat(value);
            }

            return parseInt(value);
        }
        catch (e) {
            console.log(e);
        }

        return value;

    }
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    query() {
      const selectStatement =
        (this.$data.addedColumns.length === this.$data.columns.length
          ? "SELECT *"
          : `SELECT ${this.selectedColumns.map(col => `${col}`).join(", ")}`) +
            `\nFROM ${this.$data.selectedTable}`;
      if (this.$data.addedFilters.length > 0) {
        let conditionsStatement = this.$data.addedFilters.map(
          (filter, index) => {
            let statement =
              index > 0
                ? `${filter.andOrOr} ${filter.column}`
                : `${filter.column}`;
            if (
              ["equal", "not equal", "greater than", "less than"].includes(
                filter.filter
              ) &&
              this.colType(filter.column) === "NUMERIC"
            ) {
              statement = `${statement} ${
                this.$data.operators[filter.filter]
              } ${filter.inputField1}`;
              return statement;
            } else if (
              ["equal", "not equal"].includes(filter.filter) &&
              this.colType(filter.column) === "CHARACTER"
            ) {
              statement = `${statement} ${
                this.$data.operators[filter.filter]
              } '${filter.inputField1}'`;
              return statement;
            } else if (
              ["equal", "not equal", "greater than", "less than"].includes(
                filter.filter
              ) &&
              (this.colType(filter.column) === "DATE" || this.colType(filter.column) === "SIMPLEDATE")
            ) {
              statement = `${statement} ${
                this.$data.operators[filter.filter]
              } '${filter.datePicker1}'`;
              return statement;
            } else if (
              filter.filter === "between" &&
              (this.colType(filter.column) === "DATE" || this.colType(filter.column) === "SIMPLEDATE")
            ) {
              statement = `${statement} ${
                this.$data.operators[filter.filter]
              } '${filter.datePicker1}' and '${filter.datePicker2}'`;
              return statement;
            } else if (
              ["equal", "not equal", "greater than", "less than"].includes(
                filter.filter
              ) &&
              this.colType(filter.column) === "TIME"
            ) {
              statement = `${statement} ${
                this.$data.operators[filter.filter]
              } '${filter.timePicker1}'`;
              return statement;
            } else if (
              filter.filter === "between" &&
              this.colType(filter.column) === "TIME"
            ) {
              statement = `${statement} ${
                this.$data.operators[filter.filter]
              } '${filter.timePicker1}' and '${filter.timePicker2}'`;
              return statement;
            } else if (
              ["equal", "not equal", "greater than", "less than"].includes(
                filter.filter
              ) &&
              this.colType(filter.column) === "DATETIME"
            ) {
              statement = `${statement} ${
                this.$data.operators[filter.filter]
              } '${filter.datePicker1} ${filter.timePicker1}'`;
              return statement;
            } else if (
              filter.filter === "between" &&
              this.colType(filter.column) === "DATETIME"
            ) {
              statement = `${statement} ${
                this.$data.operators[filter.filter]
              } '${filter.datePicker1} ${filter.timePicker1}' and '${
                filter.datePicker2
              } ${filter.timePicker2}'`;
              return statement;
            } else if (
              filter.filter === "between" &&
              this.colType(filter.column) === "NUMERIC"
            ) {
              statement = `${statement} ${
                this.$data.operators[filter.filter]
              } '${filter.inputField1}' and '${filter.inputField2}'`;
              return statement;
            } else if (filter.filter === "in") {
              statement = `${statement} ${
                this.$data.operators[filter.filter]
              } (${filter.fileContent})`;
              return statement;
            } else if (filter.filter === "is null" || filter.filter === "is not null") {
              statement = `${statement} ${
                this.$data.operators[filter.filter]
              }`;
              return statement;
            }
          }
        );
        return (
          selectStatement +
          "\nWHERE " +
          conditionsStatement.join("\n")
          + `\nlimit ${this.$data.numberRows}`
        );
      }
      return selectStatement + `\nlimit ${this.$data.numberRows}`;
    },
    hqlQuery() {
      if (this.$data.addedFilters.length > 0) {
        let conditionsStatement = this.$data.addedFilters.map(
          (filter, index) => {
            let statement =
              index > 0
                ? `${filter.andOrOr} ${filter.column}`
                : `${filter.column}`;
            if (
              ["equal", "not equal", "greater than", "less than"].includes(
                filter.filter
              ) &&
              this.colType(filter.column) === "NUMERIC"
            ) {
              statement = `${statement} ${
                this.$data.operators[filter.filter]
              } ${this.fixNumberFormat(filter.inputField1)}`;
              return statement;
            } else if (
              ["equal", "not equal"].includes(filter.filter) &&
              this.colType(filter.column) === "CHARACTER"
            ) {
              statement = `${statement} ${
                this.$data.operators[filter.filter]
              } '${filter.inputField1}'`;
              return statement;
            } else if (
              ["equal", "not equal", "greater than", "less than"].includes(
                filter.filter
              ) &&
              (this.colType(filter.column) === "DATE" || this.colType(filter.column) === "SIMPLEDATE")
            ) {
              statement = `${statement} ${
                this.$data.operators[filter.filter]
              } '${filter.datePicker1}'`;
              return statement;
            } else if (
              filter.filter === "between" &&
              (this.colType(filter.column) === "DATE" || this.colType(filter.column) === "SIMPLEDATE")
            ) {
              statement = `${statement} ${
                this.$data.operators[filter.filter]
              } '${filter.datePicker1}' and '${filter.datePicker2}'`;
              return statement;
            } else if (
              ["equal", "not equal", "greater than", "less than"].includes(
                filter.filter
              ) &&
              this.colType(filter.column) === "TIME"
            ) {
              statement = `${statement} ${
                this.$data.operators[filter.filter]
              } '${filter.timePicker1}'`;
              return statement;
            } else if (
              filter.filter === "between" &&
              this.colType(filter.column) === "TIME"
            ) {
              statement = `${statement} ${
                this.$data.operators[filter.filter]
              } '${filter.timePicker1}' and '${filter.timePicker2}'`;
              return statement;
            } else if (
              ["equal", "not equal", "greater than", "less than"].includes(
                filter.filter
              ) &&
              this.colType(filter.column) === "DATETIME"
            ) {
              statement = `${statement} ${
                this.$data.operators[filter.filter]
              } '${filter.datePicker1} ${filter.timePicker1}'`;
              return statement;
            } else if (
              filter.filter === "between" &&
              this.colType(filter.column) === "DATETIME"
            ) {
              statement = `${statement} ${
                this.$data.operators[filter.filter]
              } '${filter.datePicker1} ${filter.timePicker1}' and '${
                filter.datePicker2
              } ${filter.timePicker2}'`;
              return statement;
            } else if (
              filter.filter === "between" &&
              this.colType(filter.column) === "NUMERIC"
            ) {
              statement = `${statement} ${
                this.$data.operators[filter.filter]
              } '${this.fixNumberFormat(filter.inputField1)}' and '${this.fixNumberFormat(filter.inputField2)}'`;
              return statement;
            } else if (filter.filter === "in") {
              statement = `${statement} ${
                this.$data.operators[filter.filter]
              } (${filter.fileContent})`;
              return statement;
            } else if (filter.filter === "is null" || filter.filter === "is not null") {
              statement = `${statement} ${
                this.$data.operators[filter.filter]
              }`;
              return statement;
            }
          }
        );
        return (
          conditionsStatement.join("\n")
        );
      }
      return "";
    },
    columnData() {
      if (this.$data.columnSearch) {
        return this.$data.columns.filter(
          column =>
            column.field
              .toLowerCase()
              .includes(this.$data.columnSearch.toLowerCase()) ||
            column.desc.includes(this.$data.columnSearch)
        );
      }
      return this.$data.columns;
    },
    selectedColumns() {
      if (this.$data.addedColumns) {
        return this.$data.addedColumns.map(column => column.field);
      }
      return [];
    }
  },
  mounted() {
    
  }
};
</script>
